/**
 * Self-healing route guard (D2): an org that isn't onboarded has no business
 * anywhere except guided setup — landing on any app route with an un-onboarded
 * active org (navigating away mid-fork, deep links, stranded add-org shells)
 * redirects to /onboarding/chat instead of dead-ending on empty screens.
 *
 * Gated by llmOnboardingEnabled (dev/qa) so production's legacy onboarding
 * flow is untouched until the chat flow ships there.
 */
import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import UserContext from "../../../assets/user_context";
import { llmOnboardingEnabled } from "./featureGate";

// Routes an un-onboarded org may still visit: setup itself, user-level account
// management, and the public trial-extension page.
const EXEMPT_PREFIXES = ["/onboarding", "/account-settings", "/extend-trial"];

export default function UnonboardedOrgGuard({ children }) {
  const { orgData } = useContext(UserContext);
  const location = useLocation();

  const exempt = EXEMPT_PREFIXES.some((p) => location.pathname.startsWith(p));
  if (
    llmOnboardingEnabled() &&
    orgData &&
    orgData.onboarded === false &&
    !exempt
  ) {
    return <Navigate to="/onboarding/chat" replace />;
  }
  return children;
}
